import Bowser from "bowser";

export const deviceToken = () => {
  const { browser, os } = Bowser.parse(window.navigator.userAgent);
  const random = Math.floor(1000000000 + Math.random() * 900000000);
  const deviceToken = `${browser.name}${browser.version}${os.name}${random}`;
  return deviceToken;
};
